export const config = {
  backendUrl: 'https://api.vibe9.org',
  contactUuid: '03212c6a-704f-4de0-ad6e-c0cea4d305a8',
  rentalUuid: '54ea7865-baf9-48a2-adde-77ce7c7940ad'
};